<template>
    <div class="story-page">
        <div class="img">
            <img src="../assets/story_bg.png" />
        </div>
        <div class="desc" v-if="lang == 'fr'">
            <h1>Les gants et Amelie de Chassey : <br />Une histoire</h1>
            <p>
        Je suis issue d'une famille de sportifs, et à l'âge de dix ans, mon père,

        Marc de Buretel de Chassey, après nous avoir, mon frère et ma sœur

        aînés, permis de goûter à beaucoup de sports et la notion d'effort

        physique, m'a prié de me mettre au golf comme tous dans la famille

        sans discuter et ce par tous les temps... Avec mon père, nous devions

        nous exécuter sans broncher, "Never complain, never explain" mais je

        lui en suis pleinement reconnaissante.
        </p>
            <p>
        J'ai eu la chance que le golf soit pour moi une véritable révélation et ce

        sport  m'a donné beaucoup de satisfaction dès mon plus jeune âge. Le

        fait d'habiter au pays basque, où le climat et la nature étaient très

        changeants, a pu intensifier ma progression dans un sport encore

        inconnu du grand public dans les années 70. En cinq ans, j'atteignai la

        première série fédérale par la force de persuasion de mes professeurs

        et… le « courage » de mes mains... En effet, ayant une mauvaise

        circulation du sang, j’ai souvent souffert du froid, du vent, de la

        pluie… mais à l’époque, j’en faisais abstraction tant ma passion était

        dévorante.
        </p>
        <p>
        Avec l’âge et l’expérience, j’ai dû prendre plus de précautions... afin de

        pouvoir garder mon niveau de jeu. J’avais tout essayé, en vain, pour

        vaincre le froid et les intempéries : des moufles aux gants de marque,

        du bon à la très mauvaise qualité et ce dans toutes les matières ... rien

        n'y faisait, j'avais froid et sentais ma peau se refroidir jusqu’à l’os… au

        fur et à mesure que mes coups devenaient de plus en plus sourds et…

        courts.
        </p>
        <p>
        En 2000, j'ai pensé qu’il fallait que je crée ma propre paire de gants.

        J'ai contacté une des plus prestigieuses et anciennes ganteries de

        France « la Maison Fabre », gantiers de pères et fils depuis 1924, afin de

        leur exposer mon projet de créer une paire de gants sur-mesure,

        capable de lutter contre le froid, le vent, le gel, voire le déluge et en

        faire un véritable rempart contre la douleur. Un produit de luxe rien

        que pour moi, mes idées associées au savoir-faire du meilleur gantier

        artisanal de France.
        </p>
        <p>

        Un an plus tard, « l’arme fatale » était née. Nous avions mis au point

        une paire idéale de gants permettant de vaincre le froid, un nouveau

        design protégeant les mains tout en gardant la souplesse du cuir avec

        la chaleur d’une doublure de soie incorporée à chaque gant. Il ne

        manquait plus que la touche finale : le scratch « à main droite et à

        main gauche » qui assure l’étanchéité de l’ensemble et devient ma

        « seconde peau ».
        </p>

        <p>
        En dix ans de tests sur tous les terrains et particulièrement sur les

        grands links écossais, j’ai su faire évoluer la texture et le design des

        gants et me suis rendue compte que je ne les quitte plus du mois

        d'octobre au mois d'avril, tant pour le golf, que le tennis, la voiture, le

        scooter, le ski, la chasse, l'équitation, l’escrime… et même le

        jardinage… à chaque activité, ce même sentiment de chaleur, finesse,

        souplesse me faisant totalement oublier que je porte des gants.

        </p>
        <p>
        En 2011, après que de nombreux amis m’aient demandé de leur en

        procurer, j'ai décidé de commercialiser cette ligne de gants pour en

        faire profiter tous les sportifs… à commencer par tous mes amis du golf

        de Morfontaine.
        </p>

        <p>
        J'espère que vous aimerez les essayer et les porter. Et surtout que vous

        n’aurez plus jamais froid.
        </p>

        Amelie de Buretel de Chassey
        </div>

        <div class="desc" v-if="lang == 'en'">
            <h1>Amelie de Chassey & Golf Gloves : The real story</h1>
            <p>
            I was born into a family of sportsmen. At the age of ten, after giving my

            brother, sister and I a foretaste of a wide range of sports, thereby

            introducing us to the notion of physical effort, my father, Marc de

            Buretel de Chassey put me up to golf, just like every other member of

            the family. Come rain or shine, without discussion, we had to toe the

            line and forget about flinching. "Never explain, never complain”!

            Today, I feel grateful for this life lesson.
            </p>

            <p>
            My luck was that golf quickly proved to be my passion, giving me great

            satisfaction since my first swing. We were living in the Basque region

            (South West France), which changing climate and landscapes supported

            my progress in a sport that – in the 70’s - remained unknown to the

            general public. In five years, I reached the first federal series with the

            persuasion of my trainers and... the bravery of my hands ! Indeed, with

            a poor blood circulation, I can’t remember the heavenly time when I

            did not suffer from cold weather. At that time, consumed by my

            passion, I just ignored the pain.
            </p>

            <p>
            With age and experience, I had to take more precautions if I wanted to

            keep my level. I had tried everything but in vain to overcome cold

            weather : from mittens to big name brand gloves, from good to very

            poor quality, and that in all imaginable fabrics... Nothing helped: I was

            still cold, cold to the bone! Unsurprisingly, my shots were becoming

            increasingly low and short.

            </p>
            <p>
            In 1990, I came up with the idea that I had to create my own pair of

            gloves. I approached one of the oldest and most prestigious glove

            makers in France, “La Maison Fabre”, glove makers from father to son

            since 1924, and presented them my plan to create a custom pair of

            gloves, cold-proof, wind-proof, freeze-proof, in short: pain-proof. A

            pure luxury product just for me! My ideas associated with the expertise

            of the best glove craftsman in France...
            </p>
            <p>

            A year later, the “lethal weapon” was born. We had developed the

            ideal gloves to overcome bad weather and a new design to protect your

            hands while keeping the leather supple, with the warmth of a silk

            lining built into each glove. It only lacked the finishing touch: the

            appropriate Velcro strap on each hand to ensure a perfect seal and

            second-skin-like experience.
            </p>
            <p>
            Ten years of field-testing on any terrain, especially on the great links of

            Scotland, enabled me to adjust the texture and design of these gloves.

            I realized that I (almost) don’t take them off from October to April, as

            much for golf as for tennis-playing, driving, skiing, hunting,

            horseback-riding, fencing and even gardening! Every time, the same

            feeling of warmth, delicacy and flexibility makes me forget I'm wearing

            gloves.
            </p>
            <p>
            In 2011, many friends having expressed their wish to get the same

            blessing for themselves, I decided to market this line of gloves for all

            sports fans...  Starting with my golf friends in Morfontaine!

            My commitment? You'll never feel the same about being in the cold

            again.
            </p>
            Amelie de Buretel de Chassey
        </div>
    </div>
</template>

<script>
  export default {
    name: 'story-page',
    props: ['lang'],
  };
</script>
<style lang="scss">
    .story-page {
        display: flex;
        animation: fadeIn 1s;

        align-items: stretch;
        @media screen and (max-width:768px){
            flex-direction: column;
        }

        .img, .desc {
            flex: 40% 0;
        }
        @media screen and (max-width:768px) {
            .img {
                text-align: center;
            }
        }
        @media screen and (min-width:768px) {
            .img {
                text-align: right;
                margin-right: 1rem;
                margin-top: 5rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/StoryPage.vue